export default __webpack_public_path__ + "static/media/why_getboatcom.f41909b5.webp";